export const clients = [
  { id: 1, name: "Sarah Mitchell", email: "sarah@gmail.com", phone: "(312) 555-0192", source: "Zillow", budget: "$650k", location: "Lincoln Park", timeline: "3 months", status: "Contacted", score: 82, intent: "High", mortgage: true, avatar: "SM", createdAt: "2026-03-04", notes: "Interested in 3BR near park" },
  { id: 2, name: "James Okonkwo", email: "james.o@outlook.com", phone: "(773) 555-0384", source: "Facebook Ad", budget: "$420k", location: "Logan Square", timeline: "6 months", status: "New Client", score: 61, intent: "Medium", mortgage: false, avatar: "JO", createdAt: "2026-03-05", notes: "First-time buyer" },
  { id: 3, name: "Priya Sharma", email: "priya.s@gmail.com", phone: "(847) 555-0571", source: "Website", budget: "$900k", location: "River North", timeline: "1 month", status: "Showing Scheduled", score: 94, intent: "High", mortgage: true, avatar: "PS", createdAt: "2026-03-01", notes: "Pre-approved, very motivated" },
  { id: 4, name: "Derek Holloway", email: "derek.h@yahoo.com", phone: "(630) 555-0263", source: "Referral", budget: "$310k", location: "Wicker Park", timeline: "12 months", status: "New Client", score: 34, intent: "Low", mortgage: false, avatar: "DH", createdAt: "2026-03-06", notes: "Just browsing" },
  { id: 5, name: "Angela Torres", email: "angela.t@gmail.com", phone: "(312) 555-0847", source: "Instagram", budget: "$550k", location: "Gold Coast", timeline: "2 months", status: "Offer Submitted", score: 88, intent: "High", mortgage: true, avatar: "AT", createdAt: "2026-02-28", notes: "Submitted offer on 2BR condo" },
  { id: 6, name: "Marcus Webb", email: "marcus@webmail.com", phone: "(773) 555-0129", source: "Zillow", budget: "$720k", location: "Old Town", timeline: "4 months", status: "Contacted", score: 75, intent: "Medium", mortgage: true, avatar: "MW", createdAt: "2026-03-03", notes: "Looking for investment property" },
  { id: 7, name: "Chloe Beaumont", email: "chloe.b@gmail.com", phone: "(847) 555-0994", source: "Website", budget: "$280k", location: "Pilsen", timeline: "8 months", status: "New Client", score: 47, intent: "Medium", mortgage: false, avatar: "CB", createdAt: "2026-03-05", notes: "Relocating from NYC" },
  { id: 8, name: "Nathan Pierce", email: "nathan.p@gmail.com", phone: "(312) 555-0336", source: "Facebook Ad", budget: "$1.1M", location: "Streeterville", timeline: "1 month", status: "Closed", score: 97, intent: "High", mortgage: true, avatar: "NP", createdAt: "2026-02-15", notes: "Closed on luxury penthouse" },
  { id: 9, name: "Lisa Chang", email: "lisa.c@gmail.com", phone: "(312) 555-0441", source: "Zillow", budget: "$475k", location: "Lakeview", timeline: "2 months", status: "Showing Scheduled", score: 79, intent: "High", mortgage: true, avatar: "LC", createdAt: "2026-03-02", notes: "Wants walkable neighborhood" },
  { id: 10, name: "Robert Kim", email: "robert.k@outlook.com", phone: "(773) 555-0558", source: "Referral", budget: "$850k", location: "Lincoln Park", timeline: "3 months", status: "Contacted", score: 71, intent: "Medium", mortgage: true, avatar: "RK", createdAt: "2026-03-04", notes: "Referred by Nathan Pierce" },
];

export const stages = ["New Client", "Contacted", "Showing Scheduled", "Offer Submitted", "Closed"];

export const buyerStages = ["Client", "Pre-Qualified", "Active Search", "Offer Made", "Under Contract", "Inspection", "Financing", "Closed"];
export const sellerStages = ["Client", "Listing Appointment", "Listed", "Offer Received", "Under Contract", "Inspection", "Closed"];

export const stageColors = {
  "New Client": "#00a878",
  "Contacted": "#e8950a",
  "Showing Scheduled": "#2e7cf6",
  "Offer Submitted": "#e8503a",
  "Closed": "#007d5a",
  "Client": "#00a878",
  "Pre-Qualified": "#e8950a",
  "Active Search": "#2e7cf6",
  "Offer Made": "#e8503a",
  "Under Contract": "#06B6D4",
  "Inspection": "#8B5CF6",
  "Financing": "#F59E0B",
  "Listing Appointment": "#e8950a",
  "Listed": "#2e7cf6",
  "Offer Received": "#e8503a",
};

export const messages = [
  { id: 1, client: "Sarah Mitchell", avatar: "SM", msg: "Hi! Yes, I'm very interested in the Lincoln Park listing. Can we schedule a viewing this week?", time: "2m ago", unread: true },
  { id: 2, client: "Priya Sharma", avatar: "PS", msg: "I'm pre-approved for $950k. When can we meet?", time: "14m ago", unread: true },
  { id: 3, client: "Marcus Webb", avatar: "MW", msg: "What's the HOA fee for that Old Town condo?", time: "1h ago", unread: false },
  { id: 4, client: "Angela Torres", avatar: "AT", msg: "We submitted the offer. Fingers crossed!", time: "3h ago", unread: false },
  { id: 5, client: "Lisa Chang", avatar: "LC", msg: "Can we see the Lakeview property Saturday morning?", time: "5h ago", unread: false },
];

export const automations = [
  { id: 1, name: "Welcome Message", trigger: "Client Created", action: "Send Welcome Email", delay: "Instant", active: true, runs: 142 },
  { id: 2, name: "Follow-up Nurture", trigger: "No Reply (24h)", action: "Send Follow-up Email", delay: "24 hours", active: true, runs: 87 },
  { id: 3, name: "Hot Client Alert", trigger: "Score > 80", action: "Notify Agent", action2: "Send Calendar Link", delay: "Instant", active: true, runs: 34 },
  { id: 4, name: "Final Outreach", trigger: "No Reply (72h)", action: "Send Final Email", delay: "72 hours", active: false, runs: 19 },
  { id: 5, name: "Appointment Reminder", trigger: "24h Before Showing", action: "Send Reminder Email", delay: "24 hours before", active: true, runs: 56 },
];

export const metricData = [
  { week: "W1", clients: 18, replies: 9, showings: 4, deals: 1 },
  { week: "W2", clients: 24, replies: 14, showings: 6, deals: 2 },
  { week: "W3", clients: 31, replies: 19, showings: 9, deals: 3 },
  { week: "W4", clients: 28, replies: 17, showings: 8, deals: 2 },
  { week: "W5", clients: 42, replies: 26, showings: 12, deals: 4 },
  { week: "W6", clients: 38, replies: 22, showings: 10, deals: 3 },
];

export const appointments = [
  { id: 1, client: "Priya Sharma", avatar: "PS", property: "1842 N Fremont St", date: "2026-03-07", time: "10:00 AM", status: "confirmed", type: "Showing" },
  { id: 2, client: "Sarah Mitchell", avatar: "SM", property: "2100 N Lincoln Ave", date: "2026-03-07", time: "2:00 PM", status: "pending", type: "Showing" },
  { id: 3, client: "Lisa Chang", avatar: "LC", property: "3421 N Halsted St", date: "2026-03-08", time: "11:00 AM", status: "confirmed", type: "Showing" },
  { id: 4, client: "Marcus Webb", avatar: "MW", property: "1550 N State Pkwy", date: "2026-03-08", time: "3:30 PM", status: "pending", type: "Consultation" },
  { id: 5, client: "Robert Kim", avatar: "RK", property: "2200 N Clark St", date: "2026-03-09", time: "9:00 AM", status: "confirmed", type: "Showing" },
];

// Solo Agent Plans
export const soloPlans = [
  {
    key: "starter",
    name: "Starter",
    price: 39,
    category: "solo",
    description: "For individual agents getting started",
    signings: 3,
    users: 1,
    ai: "Basic",
    support: "Email",
    features: ["3 signings/month", "Basic pipeline view", "Email integration", "Basic AI features", "Email support", "1 user"],
    cta: "Start Free",
    popular: false,
  },
  {
    key: "pro",
    name: "Pro",
    price: 89,
    category: "solo",
    description: "For growing agents who want full AI power",
    signings: 10,
    users: 1,
    ai: "Full",
    support: "Priority Email",
    features: ["10 signings/month", "Full AI client scoring", "Smart email automation", "Appointment scheduling", "Analytics dashboard", "Priority email support"],
    cta: "Start Free",
    popular: true,
  },
];

// Team Plans
export const teamPlans = [
  {
    key: "team_starter",
    name: "Team Starter",
    price: 249,
    category: "team",
    description: "For small teams of agents",
    signings: 20,
    users: 5,
    ai: "Full",
    support: "Email",
    features: ["20 signings/month", "5 users included", "Full AI features", "Team management", "+$29/extra seat", "Email support"],
    cta: "Start Free",
    popular: false,
  },
  {
    key: "team_pro",
    name: "Team Pro",
    price: 549,
    category: "team",
    description: "For growing teams that need more",
    signings: 50,
    users: 15,
    ai: "Advanced",
    support: "Priority",
    features: ["50 signings/month", "15 users included", "Advanced AI features", "Team management", "+$29/extra seat", "Priority support"],
    cta: "Start Free",
    popular: true,
  },
  {
    key: "agency",
    name: "Agency",
    price: 999,
    category: "team",
    description: "For large brokerages",
    signings: 100,
    users: 50,
    ai: "Advanced + White Label",
    support: "Dedicated",
    features: ["100 signings/month", "50 users included", "Advanced AI + White Label", "Full team management", "+$19/extra seat", "Dedicated support"],
    cta: "Start Free",
    popular: false,
  },
  {
    key: "enterprise",
    name: "Enterprise",
    price: null,
    category: "team",
    description: "For enterprise brokerages",
    signings: "Custom",
    users: "Custom",
    ai: "Custom AI",
    support: "24/7",
    features: ["Custom signings", "Custom users", "Custom AI", "API & webhook access", "Dedicated account manager", "24/7 support"],
    cta: "Contact Sales",
    popular: false,
    contactSales: true,
  },
];

// All plans combined (for backward compat)
export const pricingPlans = [...soloPlans, ...teamPlans];

export const avatarColors = {
  SM: "#6B7FFF", JO: "#F59E0B", PS: "#10B981", DH: "#94A3B8",
  AT: "#F97316", MW: "#8B5CF6", CB: "#EC4899", NP: "#22C55E",
  LC: "#06B6D4", RK: "#E11D48",
};
